import { get, replace, reduce } from 'lodash/fp';

const reduceWithKey = get('convert', reduce)({ cap: false });

const pagePathToUrl = (path, params) =>
  reduceWithKey(
    (url, value, key) => replace(`:${key}`, value, url),
    path,
    params
  );

export default pagePathToUrl;
